import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks"
import { addItem, updateItem } from "../../store/slices/positiveItemSlice";
import { useFormik } from "formik";
import { useMemo, useState } from "react";
import { Button } from "primereact/button";
import { FormInputTextarea } from "../Shared/FormInputTextarea";
import { PositiveItem } from "../../types/positiveItem";
import { getPositiveItemEditableFields } from "../../utils/positiveItemTableHelper";
import { addPositiveItem, updatePositiveItem } from "../../services/positiveItemService";
import { GradingAreaMapping } from "../../config/GradingAreaMapping";
import { FormMultiSelect } from "../Shared/FormMultiSelect";
import { selectPhotoFolders } from "../../store/selectors/inspectionSelectors";

type Props = {
    positiveItem: PositiveItem;
}

export const PositiveItemForm = (props: Props) => {
    const { positiveItem } = props;

    const dispatch = useAppDispatch();

    const photoFolders = useAppSelector(selectPhotoFolders);

    const [loading, setLoading] = useState(false);

    const formik = useFormik<PositiveItem>({
        initialValues: positiveItem,
        validate: (data) => {
            let errors: Record<string, unknown> = {};

            if (!data.description) {
                errors.description = 'Description is required.';
            }

            return errors;
        },
        onSubmit: async (data) => {
            setLoading(true);

            if (positiveItem.id) {
                const updated = await updatePositiveItem(data);

                if (updated) {
                    dispatch(updateItem(data));
                }
            } else {
                const added = await addPositiveItem(data);

                if (added) {
                    dispatch(addItem(added));
                }
            }

            setLoading(false);

            formik.resetForm();
        }
    });
    
    const editableFields = useMemo(() => (
        getPositiveItemEditableFields()
    ), []);

    const gradingAreaOptions = useMemo(() => (
        Object.keys(GradingAreaMapping).map((key) => ({ label: GradingAreaMapping[key], value: key }))
    ), []);

    const photoFolderOptions = useMemo(() => (
        photoFolders.map((photoFolder) => ({
            label: photoFolder.Name,
            value: photoFolder.Id.toString(),
    }))), []);

    return (
        <div className="flex pt-2">
            <form onSubmit={formik.handleSubmit} className="flex w-full flex-column">
                <FormInputTextarea disabled={!editableFields.includes("description")} formik={formik} value="description" label="Description" />
                <FormMultiSelect disabled={!editableFields.includes("gradingArea")} formik={formik} value="gradingArea" label="Grading Area" options={gradingAreaOptions} splitter=";" />
                <FormMultiSelect disabled={!editableFields.includes("photoFolder")} formik={formik} value="photoFolder" label="Photo Folders" options={photoFolderOptions} splitter=";" />
                <Button icon={loading ? "pi pi-spin pi-spinner" : undefined} type="submit" label={loading ? undefined : "Submit"} disabled={loading} className="w-full mt-2" />
            </form>
        </div>
    )
}